import { Button } from "@/components/buttons/Button";
import { Icon } from "@/components/icons/Icon";

interface ErrorMessageProps {
    title?: string;
    message?: string[];
    buttonLabel?: string;
    onButtonClick?: () => void;
    size?: "small" | "large";
    iconName?: "sad-emoji" | "happy-with-crown" | null;
    children?: React.ReactNode;
}

export default function ErrorMessage({
    title = "אופס!",
    message = ["חלה שגיאה"],
    buttonLabel,
    onButtonClick,
    size = "large",
    iconName = "sad-emoji",
    children,
}: ErrorMessageProps) {
    return (
        <div className="h-full w-full flex flex-col items-center justify-center gap-8">
            <div
                className={`w-full flex-1 flex flex-col items-center justify-center ${
                    size === "small" ? "gap-2 py-4" : "gap-8"
                }`}
            >
                {iconName && (
                    <Icon
                        name={iconName}
                        width={size === "small" ? 70 : 144}
                        height={size === "small" ? 70 : 140}
                    />
                )}
                {children && children}
                <div className="flex flex-col items-center justify-center gap-2">
                    {size === "small" ? (
                        <h4>{title}</h4>
                    ) : (
                        <h1 style={{ fontSize: "36px", textAlign: "center" }}>
                            {title}
                        </h1>
                    )}
                    {message && 0 < message.length && (
                        <span
                            className="text-center"
                            style={{
                                fontSize: "16px",
                            }}
                            dangerouslySetInnerHTML={{
                                __html: message.join("<br />"),
                            }}
                        />
                    )}
                </div>
            </div>
            {buttonLabel && (
                <Button variant="primary" onClick={onButtonClick || (() => {})}>
                    {buttonLabel}
                </Button>
            )}
        </div>
    );
}
